import type { FaireProductEntity } from "../../entity_types/product";

export const p_7rlbf7oo: FaireProductEntity = {
  token: "p_7rlbf7oo",
  type: "product",
  name: "Colorful Thanks | Thank You Card (Boxed Set of 6)",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/8d1c1c0f333c7c991557c888931b161411578051463fe8c3835b1638eb75f4b7.png",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/e290386bc47ebedb7f1451dedd809dad2c86fcdbb0e922810b8378db2d994e62/1528386060.png",
    "https://cdn.faire.com/res/hszgttpjt/image/upload/393b1bd8632302454b9c39585241774a88ce03c1a5130dea8f8c8b417efb1dff/1528386060.png",
    "https://cdn.faire.com/fastly/74ab1cd9106044f417b52f0e044809290a67c60ba1caf2733f3d7dce8df65fb0.png",
  ],
  priceDollars: 11,
  description:
    "Hard to keep this one in stock, it fits the bill for just about every thank you note you'd need to write. And it looks comtemporary-fancy. You know.\n\nEach E. Frances greeting card begins as an original watercolor painting, is then printed in brilliant color on luxe, heavyweight paper and is finally kissed with gold foil.\n \nMade in the USA.",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:47.833Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
